export default "__VITE_ASSET__VHF1UnNe__"